import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RestClient } from "../../Api/DcoApi/Client/RestClient";
import { Patient } from "../../Api/DcoApi/Patient";
import { ToDo } from "../../Api/DcoApi/AktenEintraege/ToDo";
import { Observable } from "rxjs/internal/Observable";
import { DateSelect } from "./DateSelect";
import { DatePipe } from "@angular/common";

@Component({
  selector: 'ToDos',
  templateUrl: './ToDos.html',
  styleUrl: './ToDos.css',
  imports: [FormsModule, DateSelect, DatePipe],
  standalone: true,
})
export class ToDos implements OnChanges {

  constructor(private cdr: ChangeDetectorRef) { }

  Client: RestClient = new RestClient();
  @Input() patient: Patient | null | undefined = null;
  @Input() Items: ToDo[] = [];
  @Output() ItemsChange = new EventEmitter<ToDo[]>();
  EditItem: ToDo | null = null;




  selectItem(todo: ToDo) {
    this.EditItem = todo;
  }

  newItem() {
    this.EditItem = { key: 0 } as ToDo;
  }
  Close() {
    this.EditItem = null;
  }

  async CreateUpdate() {
    if (this.patient != null && this.EditItem != null) {

      if (this.EditItem.key == 0) {
        await this.Client.Post<ToDo[], ToDo>(`/Backend/Api/V2/Akte/${this.patient.versicherungsnummer}/ToDo/Create`, this.EditItem)
      }
      else {
        await this.Client.Put<ToDo[], ToDo>(`/Backend/Api/V2/Akte/${this.patient.versicherungsnummer}/ToDo/Update`, this.EditItem)
      }
      this.Items = await this.Client.Get<ToDo[]>(`/Backend/Api/V2/Akte/${this.patient.versicherungsnummer}/ToDo`)
      this.EditItem = null;
      this.ItemsChange.emit(this.Items);
      this.cdr.detectChanges();
    }
  }

  async SetFinished(item: ToDo) {
    if (this.patient != null) {

      item.erledigt = true;
      await this.Client.Put<ToDo[], ToDo>(`/Backend/Api/V2/Akte/${this.patient.versicherungsnummer}/ToDo/Update`, item);

      this.Items = await this.Client.Get<ToDo[]>(`/Backend/Api/V2/Akte/${this.patient.versicherungsnummer}/ToDo`)
      this.ItemsChange.emit(this.Items);
      this.cdr.detectChanges();
    }
  }


  async ngOnChanges(changes: SimpleChanges) {

    if (changes['patient'] && this.patient != null) {

      this.Items = await this.Client.Get<ToDo[]>(`/Backend/Api/V2/Akte/${this.patient.versicherungsnummer}/ToDo`)
      this.ItemsChange.emit(this.Items);
      this.cdr.detectChanges();
    }
  }

  isOverDu(item: ToDo): boolean {

    if (item == undefined)
      return true;

    if (item.zuErledigenBis == undefined || item.erledigt)
      return false;

    return new Date(item.zuErledigenBis) < new Date()
  }

  hasOneWeek(item: ToDo): boolean {
    if (item == undefined)
      return true;

    if (item.zuErledigenBis == undefined || item.erledigt)
      return false;

    const date = new Date();     
    date.setDate(date.getDate() + 7);

   // console.log(date);

    return new Date(item.zuErledigenBis) > new Date() && new Date(item.zuErledigenBis) < date;
  }

}


